import React from "react";
import "../styles/Services.css";
import { useLanguage } from "../contexts/LanguageContext";

const ICONS = {
  landing: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="4" width="18" height="14" rx="2" />
      <path d="M3 9h18" strokeLinecap="round" />
      <circle cx="6.5" cy="6.5" r="0.6" fill="currentColor" />
      <circle cx="9" cy="6.5" r="0.6" fill="currentColor" />
      <path d="M7 13l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  fullstack: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 3l9 5-9 5-9-5 9-5z" strokeLinejoin="round" />
      <path d="M3 13l9 5 9-5" strokeLinejoin="round" />
      <path d="M3 17l9 5 9-5" strokeLinejoin="round" />
    </svg>
  ),
  automation: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  ),
  crm: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" strokeLinecap="round" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" strokeLinecap="round" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" strokeLinecap="round" />
    </svg>
  ),
  telegram: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M22 3L2 11l7 3 3 7 10-18z" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M9 14l6-6" strokeLinecap="round" />
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M21 12a9 9 0 1 1-3.5-7.1L21 4l-1 4a8.96 8.96 0 0 1 1 4z" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M8 11c1 2.5 2.5 4 5 5l1.5-1.5 2.5 1c-.5 1.5-2 2-3 2-3.5 0-7-3.5-7-7 0-1 .5-2.5 2-3l1 2.5L8 11z" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  ),
};

const Services = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const s = text.services;

  return (
    <section id="services" className="services-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{s.eyebrow}</span>
      <h2 className="section-title">{s.title}</h2>
      <p className="services-lede">{s.lede}</p>

      <div className="services-grid">
        {s.items.map((item) => (
          <article key={item.key} className="service-card">
            <div className="service-icon" aria-hidden="true">
              {ICONS[item.key]}
            </div>
            <h3 className="service-title">{item.title}</h3>
            <p className="service-desc">{item.desc}</p>
            <ul className="service-bullets">
              {item.bullets.map((b) => (
                <li key={b}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <a className="service-link" href="#contact">
              {isHeb ? "להצעת מחיר" : "Get a quote"}
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2">
                <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Services;
